import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBtn,{attrs:{"type":"submit","color":"primary","disabled":_vm.disabled || _vm.pending,"loading":_vm.pending},on:{"click":_vm.click}},[_vm._v("Save")])
}
var staticRenderFns = []

export { render, staticRenderFns }